import { call, put, all, takeEvery } from "redux-saga/effects";

import { favoriteActions } from '../slice/favoriteSlice'
import { getFavoriteApi, removeFavoriteApi } from 'services/favoriteServices'
import ShowToast from "utils/ShowToast";


function* handleGetFavorite(action) {
    try {
        const res = yield call(getFavoriteApi, action.payload.page, action.payload.perPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(favoriteActions.getFavoriteSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(favoriteActions.getFavoriteFailed())
            }
        }
        else {
            yield put(favoriteActions.getFavoriteFailed())
        }
    } catch (error) {
        yield put(favoriteActions.getFavoriteFailed())
    }
}

function* handleRemoveFavorite(action) {
    try {
        const res = yield call(removeFavoriteApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(favoriteActions.removeFavoriteSuccess())
                yield put(favoriteActions.getFavorite({ page: action.payload.page, perPage: action.payload.perPage }))
                ShowToast('success', 'Xóa tour thành công')
            }
            else {
                yield put(favoriteActions.removeFavoriteFailed())
                ShowToast('error', 'Xóa tour thất bại, vui lòng thử lại sau')
            }
        }
        else {
            yield put(favoriteActions.removeFavoriteFailed())
            ShowToast('error', 'Xóa tour thất bại, vui lòng thử lại sau')
        }
    } catch (error) {
        yield put(favoriteActions.removeFavoriteFailed())
        ShowToast('error', 'Xóa tour thất bại, vui lòng thử lại sau')
    }
}


export default function* rootSaga() {
    yield all(
        [
            takeEvery(favoriteActions.getFavorite.type, handleGetFavorite),
            takeEvery(favoriteActions.removeFavorite.type, handleRemoveFavorite),
        ]
    )
}
